import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';

import type { FieldValues, UseFormReturn } from 'react-hook-form';
import type { HNSkjemaFrontend } from 'src/types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';

interface Props {
  reactHookFormMethods: UseFormReturn<FieldValues, unknown>;
  onSubmit: () => void;
  trackFormError: () => void;
  erSendOgLagreKnapperDisabled: boolean;
}

const FormButtonsMicrowebOppgave = ({
  reactHookFormMethods,
  onSubmit,
  trackFormError,
  erSendOgLagreKnapperDisabled,
}: Props): React.JSX.Element => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);

  const onSubmitButtonClicked = (): void => {
    const handleSubmit = reactHookFormMethods.handleSubmit(
      () => onSubmit(),
      () => trackFormError()
    );
    handleSubmit();
  };

  return (
    <div className="formButtonsWrapper" data-testid="form-buttons-microweb-oppgave">
      <div className="formButtonInnerWrapper">
        <Button type="submit" disabled={erSendOgLagreKnapperDisabled} onClick={onSubmitButtonClicked} testId="submit-button">
          {resources?.formSend_skjema_i_oppgave}
        </Button>
      </div>
    </div>
  );
};

export default FormButtonsMicrowebOppgave;
